import React from 'react';
import 'twin.macro';

interface Props {
  children: [React.ReactNode, React.ReactNode];
}

export function SimpleTextWithIconsItem(props: Props) {
  const { children } = props;
  return (
    <li tw="flex items-start">
      <div tw="shrink-0">{children[0]}</div>
      <div tw="ml-2">{children[1]}</div>
    </li>
  );
}
